const typography = (_palette) => ({
  h1: {
    color: '#000',
    fontWeight: 700,
    fontSize: '24px',
    letterSpacing: 'normal',
    lineHeight: '32px',
  },
  h2: {
    color: '#000',
    fontWeight: 700,
    fontSize: '22px',
    letterSpacing: 'normal',
    lineHeight: '30px',
  },
  h3: {
    color: '#000',
    fontWeight: 700,
    fontSize: '20px',
    letterSpacing: 'normal',
    lineHeight: '28px',
  },
  h4: {
    color: '#000',
    fontWeight: 600,
    fontSize: '16px',
    letterSpacing: 'normal',
    lineHeight: '24px',
  },
  h5: {
    color: '#000',
    fontWeight: 700,
    fontSize: '14px',
    letterSpacing: 'normal',
    lineHeight: '20px',
  },
  h6: {
    color: '#000',
    fontWeight: 700,
    fontSize: '12px',
    letterSpacing: 'normal',
    lineHeight: '18px',
  },
  subtitle1: {
    color: '#000',
    fontWeight: 500,
    fontSize: '16px',
    letterSpacing: 'normal',
    lineHeight: '24px',
  },
  subtitle2: {
    color: '#000',
    fontWeight: 500,
    fontSize: '14px',
    letterSpacing: 'normal',
    lineHeight: '20px',
  },
  // Body/Large
  body1: {
    color: '#000',
    fontWeight: 400,
    fontSize: '16px',
    letterSpacing: 'normal',
    lineHeight: '24px',
  },
  // Body/Medium
  body2: {
    color: '#000',
    fontWeight: 400,
    fontSize: '14px',
    letterSpacing: 'normal',
    lineHeight: '20px',
  },
  // Body/Small
  body3: {
    color: '#000',
    fontWeight: 400,
    fontSize: '12px',
    letterSpacing: 'normal',
    lineHeight: '18px',
  },
  button: {
    color: '#000',
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: 'normal',
    lineHeight: '20xp',

    // TODO: use this to remove upper case from buttons
    textTransform: 'none',
  },
  caption: {
    color: '#000',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '18xp',
    letterSpacing: 'normal',
  },
  info: {
    color: '#000',
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: 'normal',
    lineHeight: '20px',
  },
  overline: {
    color: '#000',
    fontSize: '12px',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: '13px',
    textTransform: 'uppercase',
  },
});

export default typography;
